import axios from 'axios'
import config from '@/config'

import { FEATURES } from '../helpers/constants'

const instance = axios.create({
	baseURL: config('PaltaApiUrl'),
	headers: {
		'x-api-key': config('PaltaApiKey'),
		'Content-Type': 'application/json;charset=utf-8'
	}
})

export const paltaApi = {
	/**
	 * Existing price points: https://developer.paltabrain.com/payments-v2/price-configurator/get-price-points
	 * Api doc: https://api.payments.paltabrain.com/docs/merchants#/showcase/showcase_get_price_points_showcase_get_price_points_post
	 * @param {String} customerId
	 * @param {Object} params
	 * @returns {Promise}
	 */
	fetchPricePoints(customerId, params) {
		const { ident = [], feature = FEATURES.SIMPLE_PREMIUM } = params
		return instance
			.post('/showcase/get-price-points', {
				platformCode: 'desktop_web',
				customerId: {
					type: 'merchant-uuid',
					value: customerId
				},
				ident,
				availabilityRules: true,
				requestContext: {
					feature
				}
			})
			.then((response) => {
				return response.data.pricePoints
			})
	},

	fetchSubscriptions(customerId, ids = []) {
		return instance
			.post('/subscriptions-tracker/get-subscriptions', {
				customerId: {
					type: 'merchant-uuid',
					value: customerId
				},
				onlyIds: ids
			})
			.then((response) => {
				return response.data
			})
	},

	fetchFeatures(customerId) {
		return instance
			.post('/feature-provisioner/get-features', {
				customerId: {
					type: 'merchant-uuid',
					value: customerId
				}
			})
			.then((response) => {
				return response.data.features
			})
	},

	purchase({ user_id, ident, payment_type, exclude_trial_amount = false }) {
		return fetch(config('SimpleAPIUrl') + 'v1/api/subscription/paltabrain/upsale', {
			method: 'POST',
			body: JSON.stringify({
				user_id,
				ident,
				payment_type,
				exclude_trial_amount
			})
		}).then((response) => response.json())
	}
}
